<template>
  <div class="single-post-skeleton">
    <div class="single-post-skeleton-card">
      <!-- Header -->
      <div class="single-post-skeleton-header">
        <div class="single-post-skeleton-avatar"></div>
        <div class="single-post-skeleton-user-info">
          <div class="single-post-skeleton-name"></div>
          <div class="single-post-skeleton-meta">
            <div class="single-post-skeleton-time"></div>
            <div class="single-post-skeleton-dot"></div>
            <div class="single-post-skeleton-visibility"></div>
          </div>
        </div>
        <div class="single-post-skeleton-menu"></div>
      </div>

      <!-- Content -->
      <div class="single-post-skeleton-content">
        <div class="single-post-skeleton-text-line"></div>
        <div class="single-post-skeleton-text-line"></div>
        <div class="single-post-skeleton-text-line"></div>
        <div class="single-post-skeleton-text-line medium"></div>
      </div>

      <!-- Image Placeholder -->
      <div class="single-post-skeleton-image"></div>

      <!-- Stats -->
      <div class="single-post-skeleton-stats">
        <div class="single-post-skeleton-stat"></div>
        <div class="single-post-skeleton-stat"></div>
      </div>

      <!-- Actions -->
      <div class="single-post-skeleton-actions">
        <div class="single-post-skeleton-action-btn"></div>
        <div class="single-post-skeleton-action-btn"></div>
        <div class="single-post-skeleton-action-btn"></div>
      </div>

      <!-- Comments Section -->
      <div class="single-post-skeleton-comments">
        <div class="single-post-skeleton-comment-input"></div>

        <!-- Comment Items -->
        <div v-for="i in 2" :key="i" class="single-post-skeleton-comment">
          <div class="single-post-skeleton-comment-avatar"></div>
          <div class="single-post-skeleton-comment-content">
            <div class="single-post-skeleton-comment-name"></div>
            <div class="single-post-skeleton-comment-text"></div>
            <div class="single-post-skeleton-comment-text short"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SinglePostSkeleton",
};
</script>

<style scoped>
.single-post-skeleton {
  width: 100%;
}

.single-post-skeleton-card {
  background: #ffffff;
  border: 1px solid #e0dfdc;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

/* Header */
.single-post-skeleton-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}

.single-post-skeleton-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
}

.single-post-skeleton-user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.single-post-skeleton-name {
  width: 160px;
  height: 18px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.single-post-skeleton-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.single-post-skeleton-time {
  width: 70px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.single-post-skeleton-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #e0e0e0;
}

.single-post-skeleton-visibility {
  width: 50px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.single-post-skeleton-menu {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
}

/* Content */
.single-post-skeleton-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.single-post-skeleton-text-line {
  width: 100%;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.single-post-skeleton-text-line.medium {
  width: 75%;
}

/* Image */
.single-post-skeleton-image {
  width: 100%;
  height: 350px;
  border-radius: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 16px;
}

/* Stats */
.single-post-skeleton-stats {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  margin-bottom: 12px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.single-post-skeleton-stat {
  width: 100px;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* Actions */
.single-post-skeleton-actions {
  display: flex;
  gap: 16px;
  padding: 16px 0;
  margin-bottom: 20px;
}

.single-post-skeleton-action-btn {
  width: 90px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

/* Comments */
.single-post-skeleton-comments {
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
}

.single-post-skeleton-comment-input {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-bottom: 20px;
}

.single-post-skeleton-comment {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.single-post-skeleton-comment-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
}

.single-post-skeleton-comment-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.single-post-skeleton-comment-name {
  width: 120px;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.single-post-skeleton-comment-text {
  width: 100%;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.single-post-skeleton-comment-text.short {
  width: 60%;
}

/* Shimmer Animation */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .single-post-skeleton-card {
    padding: 16px;
  }

  .single-post-skeleton-avatar {
    width: 48px;
    height: 48px;
  }

  .single-post-skeleton-image {
    height: 250px;
  }

  .single-post-skeleton-actions {
    gap: 12px;
  }

  .single-post-skeleton-action-btn {
    flex: 1;
  }
}
</style>
